import { GraphQLError } from 'graphql';
import { graphql } from 'msw';

import { UpdateUserConsentsMutation } from '../queries/updateUserConsents.generated';

export const generatePreferencesHandler = (
    response: UpdateUserConsentsMutation['updateUserConsents']
) => {
    return graphql.mutation<UpdateUserConsentsMutation>(
        'updateUserConsents',
        (_, res, ctx) => {
            return res(ctx.data({ updateUserConsents: response }));
        }
    );
};

export const generatePreferencesErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.mutation<UpdateUserConsentsMutation>(
        'updateUserConsents',
        (_, res, ctx) => {
            return res(ctx.errors([graphqlError]));
        }
    );
};

export const defaultPreferencesHandler = generatePreferencesHandler(true);

export const preferencesFailHandler = generatePreferencesHandler(false);

export const preferencesServerErrorHandler =
    generatePreferencesErrorHandler('Arbitrary error');
